<app-common-form [data]="data" [activeForm]="activeForm" (onFormCompletion)="handleFormSubmission($event)"></app-common-form>